module.exports = __webpack_public_path__ + "img/r1.1ba8d16f.jpg";